import React, { useState, useEffect, useRef } from 'react';
import Moment from 'react-moment';
import 'moment/locale/de';
import {MODIMAGEPATH} from '../api';

function BottomSection(props) {
    return (
        <>
        <div className="wetlarge_left">
            {
            props.linkurlleft && props.linktextleft ?
                <a rel='noreferrer' target="_blank" href={props.linkurlleft} title={props.linktitleleft} alt={props.linktitleleft}>{props.linktextleft}</a>
            :
                props.linktextleft
            }
        </div>
        <div className="wetlarge_right">
            {
            props.linkurlright && props.linktextright ?
                <a rel='noreferrer' target="_blank" href={props.linkurlright} title={props.linktitleright} alt={props.linktitleright}>{props.linktextright}</a>
            :
                props.linktextright
            }
        </div>
        </>
    );
}

export default BottomSection;